<template>
  <div class="kpi">
    <v-skeleton-loader
      v-if="cargandoDatos"
      class="cargando"
      type="image"
      height="500px"
      max-height="500px"
    ></v-skeleton-loader>
    <div v-else>
      <div v-if="graficaVacia" class="graficaVacia">
        <v-chip>No existen registros</v-chip>
      </div>
      <div v-else class="canvas">
        <highcharts :options="chartOptions"></highcharts>
      </div>
    </div>
  </div>
</template>

<script>
import { Chart } from "highcharts-vue";
import obtenerDatosKPI from "../../services/graficas/obtenerDatos";

export default {
  name: "MutacionesBiomarcadores",
  props: {
    selectedCountry: {
      type: String,
      default: 'argentina',
    },
  },
  components: { highcharts: Chart },
  data() {
    return {
      cargandoDatos: true,
      graficaVacia: false,
      colors: ["#FDCA40", "#356CFF", "#3ECF8E"],
      colorsKPIDona: ["#5AC5F3", "#EC4860", "#4C2783", "#ED9E30"],
      filtros: this.$store.state.filtros,
      mutaciones: [],
      categorias: [],
    };
  },
  watch: {
    'filtros.fecha': {
      handler() {
        this.actualizarGrafica();
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    chartOptions() {
      const procesarDatos = (data, tipo) => {
        const filteredData = data
          .filter(d => parseFloat(d[tipo]) > 0)
          .map(d => parseFloat(d[tipo]));

        if (filteredData.length === 0) return [];

        const sortedData = filteredData.sort((a, b) => a - b);
        const q1 = sortedData[Math.floor((sortedData.length / 4))];
        const median = sortedData[Math.floor((sortedData.length / 2))];
        const q3 = sortedData[Math.floor((sortedData.length * (3 / 4)))];
        const min = sortedData[0];
        const max = sortedData[sortedData.length - 1];

        return [[min, q1, median, q3, max]];
      };

      const dataTPS = procesarDatos(this.mutaciones, 'valor_tps');
      const dataCPS = procesarDatos(this.mutaciones, 'valor_cps');

      return {
        credits: { enabled: false },
        chart: { 
          type: 'boxplot', 
          zoomType: 'x',
          backgroundColor: 'transparent',
          style: {
            fontFamily: 'Arial, sans-serif'
          }
        },
        title: { 
          text: "Resultados de prueba PDL1",
          style: {
            color: '#482474',
            fontWeight: 'bold',
            fontSize: '16px'
          }
        },
        xAxis: { 
          categories: ['TPS', 'CPS'], 
          crosshair: true, 
          labels: { 
            rotation: -45, 
            style: { 
              fontSize: '13px',
              color: '#333333'
            }
          },
          lineColor: '#dddddd',
          tickColor: '#dddddd'
        },
        yAxis: { 
          min: 0, 
          title: { 
            text: 'Valor',
            style: {
              color: '#666666',
              fontWeight: 'normal'
            }
          },
          gridLineColor: '#eeeeee'
        },
        tooltip: {
          useHTML: true,
          shared: true,
          backgroundColor: 'rgba(255, 255, 255, 0.95)',
          borderWidth: 1,
          borderColor: '#dddddd',
          borderRadius: 8,
          shadow: true,
          formatter: function() {
            let tooltip = `<div style="font-size:12px;margin-bottom:5px;font-weight:bold;color:#482474">${this.x}</div><table>`;
            this.points.forEach(point => {
              tooltip += `<tr><td style="color:${point.color};padding:2px;font-weight:bold">${point.series.name}</td>` +
                `<td></td></tr>` +
                `<tr><td style="color:#666;padding:2px">Mínimo: </td>` +
                `<td style="padding:2px;text-align:right"><b>${point.point.low.toFixed(1)}</b></td></tr>` +
                `<tr><td style="color:#666;padding:2px">Q1: </td>` +
                `<td style="padding:2px;text-align:right"><b>${point.point.q1.toFixed(1)}</b></td></tr>` +
                `<tr><td style="color:#666;padding:2px">Mediana: </td>` +
                `<td style="padding:2px;text-align:right"><b>${point.point.median.toFixed(1)}</b></td></tr>` +
                `<tr><td style="color:#666;padding:2px">Q3: </td>` +
                `<td style="padding:2px;text-align:right"><b>${point.point.q3.toFixed(1)}</b></td></tr>` +
                `<tr><td style="color:#666;padding:2px">Máximo: </td>` +
                `<td style="padding:2px;text-align:right"><b>${point.point.high.toFixed(1)}</b></td></tr>`;
            });
            tooltip += '</table>';
            return tooltip;
          }
        },
        plotOptions: {
          boxplot: {
            fillColor: 'rgba(72, 36, 116, 0.1)',
            lineWidth: 2,
            medianColor: '#482474',
            medianWidth: 3,
            stemColor: '#777777',
            stemWidth: 1,
            whiskerColor: '#777777',
            whiskerWidth: 2,
            whiskerLength: '50%'
          }
        },
        series: [
          {
            name: 'TPS',
            color: '#5AC5F3',
            data: dataTPS
          },
          {
            name: 'CPS',
            color: '#4C2783',
            data: dataCPS
          }
        ],
        responsive: {
          rules: [{
            condition: {
              maxWidth: 500
            },
            chartOptions: {
              title: {
                style: {
                  fontSize: '14px'
                }
              },
              xAxis: {
                labels: {
                  style: {
                    fontSize: '11px'
                  }
                }
              },
              yAxis: {
                title: {
                  style: {
                    fontSize: '11px'
                  }
                }
              }
            }
          }]
        }
      };
    }
  },
  methods: {
    async actualizarGrafica() {
      try {
        this.cargandoDatos = true;
        const resp = await obtenerDatosKPI(this, '/pdl1-tps-cps', this.$store.getters.objetoPeticion(),  this.selectedCountry, process.env.VUE_APP_URL_MS);
        this.graficaVacia = !resp.length;
        if (!this.graficaVacia) {
          this.categorias = ['TPS', 'CPS'];
          this.mutaciones = resp;
        }
      } catch (error) {
        console.error('Error fetching data: ', error);
        this.graficaVacia = true;
      } finally {
        this.cargandoDatos = false;
      }
    }
  },
  created() {
    this.actualizarGrafica();
  },
};
</script>

<style scoped>
.kpi {
  min-height: 400px;
  height: 100%;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  background-color: white;
  padding: 10px;
}
.graficaVacia {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
  font-weight: 500;
}
.cargando {
  padding: 20px;
}
.canvas {
  padding: 5px;
  height: 100%;
}
</style>
